import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";
import { REACT_APP_NAV_ROUTES } from "../../router/AppNavigation";

const AgentTools = Loadable(
  lazy(() =>
    import("./AgentTools").then(({ AgentTools }) => ({
      default: AgentTools,
    })),
  ),
);

export const AgentToolsRoutes = [
  {
    path: REACT_APP_NAV_ROUTES.GenAI.AgentTools,
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.AGENT_TOOLS]} allowFullAccess>
        <AgentTools />
      </AuthorizedRoute>
    ),
  },
];
